
import { useLanguage } from "@/contexts/LanguageContext";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";

const ValidationWarning = () => {
  const { t } = useLanguage();
  const [validationStatus, setValidationStatus] = useState({
    locations: false,
    duration: false,
    campaignName: false,
    creatives: false
  });
  
  // Check validation status on mount
  useEffect(() => {
    // Check for locations
    const savedLocations = localStorage.getItem('selectedLocations');
    const hasLocations = savedLocations && savedLocations !== '[]';
    
    // Check for duration
    const duration = localStorage.getItem('duration');
    const hasDuration = duration && parseInt(duration) > 0;
    
    // Check for campaign name
    const campaignName = localStorage.getItem('campaignName');
    const hasCampaignName = campaignName && campaignName.trim() !== '';
    
    // Check for creatives
    const creativeUrls = localStorage.getItem('creativeUrls');
    const allCreativeUrls = localStorage.getItem('allCreativeUrls');
    const mediaOwnerCreativeUrls = localStorage.getItem('mediaOwnerCreativeUrls');
    
    const hasCreatives = 
      (creativeUrls && creativeUrls !== '[]') || 
      (allCreativeUrls && allCreativeUrls !== '[]') || 
      (mediaOwnerCreativeUrls && mediaOwnerCreativeUrls !== '[]');
    
    setValidationStatus({
      locations: hasLocations,
      duration: hasDuration,
      campaignName: hasCampaignName,
      creatives: hasCreatives
    });
    
    console.log('ValidationWarning status check:', {
      hasLocations,
      hasDuration,
      hasCampaignName,
      hasCreatives,
      savedLocations,
      duration,
      campaignName,
      creativeUrls
    });
  }, []);
  
  return (
    <div className="mt-4 space-y-4">
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>{t("error") || "Error"}</AlertTitle>
        <AlertDescription>
          {t("campaignValidationFailed") || "Please complete all previous steps before proceeding to payment."}
        </AlertDescription>
      </Alert>
      
      <div className="p-3 bg-blue-50 border border-blue-200 rounded-md text-blue-800">
        <p className="font-medium">Required steps:</p>
        <ul className="text-sm list-inside mt-1">
          {Object.entries(validationStatus).map(([key, isValid]) => (
            <li key={key} className="flex items-center mt-1">
              {isValid ? (
                <CheckCircle2 className="h-4 w-4 text-green-500 mr-2 inline" />
              ) : (
                <AlertTriangle className="h-4 w-4 text-red-500 mr-2 inline" />
              )}
              {key === 'locations' && `Selected location${validationStatus.locations ? ' ✓' : ' ⨯'}`}
              {key === 'duration' && `Set campaign duration${validationStatus.duration ? ' ✓' : ' ⨯'}`}
              {key === 'campaignName' && `Named your campaign${validationStatus.campaignName ? ' ✓' : ' ⨯'}`}
              {key === 'creatives' && `Uploaded creative assets${validationStatus.creatives ? ' ✓' : ' ⨯'}`}
            </li>
          ))}
        </ul>
        <p className="text-sm mt-2">
          Please return to the previous steps and complete all missing requirements.
          {!validationStatus.locations && <span className="block mt-1 font-medium">→ Go to "Location" step to select locations</span>}
          {!validationStatus.duration && <span className="block mt-1 font-medium">→ Go to "Time" step to set duration</span>}
          {!validationStatus.campaignName && <span className="block mt-1 font-medium">→ Go to "Content" step to name your campaign</span>}
          {!validationStatus.creatives && <span className="block mt-1 font-medium">→ Go to "Content" step to upload creative assets</span>}
        </p>
      </div>
    </div>
  );
};

export default ValidationWarning;
